import type { ConfigModel } from "./ConfigModel";
import type { ZekayConfig, ConfigAssetUploadResponse } from "./Config.typed";

export class ConfigAdapter {
  constructor(private model: ConfigModel) {}

  async getConfig(): Promise<ZekayConfig | undefined> {
    return this.model.getConfig();
  }

  async updateConfig(c: ZekayConfig): Promise<void> {
    return this.model.updateConfig(c);
  }

  async uploadConfigAsset(
    file: Blob,
    name?: string,
    field?: "logo" | "logo_qr",
  ): Promise<ConfigAssetUploadResponse> {
    return this.model.uploadConfigAsset(file, name, field);
  }

  async deleteConfigAsset(field: "logo" | "logo_qr"): Promise<void> {
    return this.model.deleteConfigAsset(field);
  }

  async getGoogleLabels(): Promise<string[]> {
    return this.model.getGoogleLabels();
  }
}
